<label [for]="fieldId"
       [class.mandatory]="isMandatory()">
  {{ label }}
</label>
<input [id]="fieldId"
       [type]="type"
       [formControl]="control"
       appDynamicDateMaxLength
       appResetDateSpecialValues
       [class.is-invalid]="isInvalid()"
       appSaveLastFocussedConditionally [saveLastFocussedEnabled]="saveLastFocusedEnabled"
       appFixDateConditionally [fixDateEnabled]="fixDateEnabled" [appFixDateType]="fixDateType" [unknownReplacement]="fixDateUnknownReplacement"
       class="form-control form-control-sm"
       [ngbPopover]="assistantServiceEnabled ? popOverName : ''">
<ng-template #popOverName>
  <app-assistant (assistantDisabled)="disableAssistant()">
    <ng-content></ng-content>
  </app-assistant>
</ng-template>
